module.exports = __webpack_public_path__ + "img/mycars.7520cca5.png";